import type { ReactNode } from "react";
// Reuses the shared .wp-banner styles (success variant) — see
// provisional-banner.css. Kept as its own component (not a prop on
// ProvisionalBanner) so the provisional banner's public props stay frozen.
import "./provisional-banner.css";

export interface ClosedBannerProps {
  title: string;
  description?: string;
  action?: ReactNode;
}

export function ClosedBanner({ title, description, action }: ClosedBannerProps) {
  return (
    <aside className="wp-banner wp-banner--success" role="status">
      <span aria-hidden="true" className="wp-banner__icon">
        ✓
      </span>
      <div className="wp-banner__body">
        <p className="wp-banner__title">{title}</p>
        {description ? <p className="wp-banner__desc">{description}</p> : null}
      </div>
      {action ? <div className="wp-banner__action">{action}</div> : null}
    </aside>
  );
}
